import React from "react";
import ReduxThunk from "./reduxThunk/reduxThunk";
import UseFetch from "./useFetch/useFetch";
import {Col, Row} from "antd";
import {convertTimeSignatureToMins} from "helper/common";
const CallApi = () => {
  const {min, second} = convertTimeSignatureToMins(
    "2023-07-10T06:03:30+07:00",
    "2023-07-10T06:02:45+07:00"
  );

  return (
    <div className="">
      <Row style={{width: "100%"}} gutter={[16, 16]}>
        <Col flex={"auto"}>
          <ReduxThunk></ReduxThunk>
        </Col>
        <Col flex={"auto"}>
          <UseFetch></UseFetch>
        </Col>
      </Row>
    </div>
  );
};
export default CallApi;
